import { useContext } from "react";
import { observer } from "mobx-react";
import styles from "./styles.module.scss";
import { useNavigate } from "react-router-dom";
import paths from "~/paths";
import SearchBarContext from "~/SearchBarContext";
import DocumentForm from "~/components/DocumentForm";
import SearchQuery from "~/searchQuery";
import FormGroup from "~/components/FormGroup";
import FormHint from "~/components/FormHint";
import { Input } from "~/components/ui/input";
import { Button } from "~/components/ui/button";

const AdvancedSearchMenu = observer(() => {
  const { searchQuery, setSearchQuery } = useContext(SearchBarContext);
  const navigate = useNavigate();
  const canSubmit = searchQuery.isOneOfTheFieldsSelected();
  const onSubmit = () => navigate(paths.construct.browse(searchQuery));
  return (
    <div className={styles.rightColumn}>
      <h1 className="mb-6 text-2xl font-semibold">Advanced search</h1>
      <div className="mb-6">
        <FormGroup
          legendText={
            <>
              Search anywhere
              <FormHint>
                A longer description. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod
                tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et
                justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est
              </FormHint>
            </>
          }
        >
          <Input
            placeholder="Search documents by title, content, tags..."
            value={searchQuery.searchAnywhere}
            onChange={(e) => setSearchQuery(searchQuery.set("searchAnywhere", e.target.value))}
          />
        </FormGroup>
      </div>

      <DocumentForm
        multipleDocs={true}
        value={searchQuery}
        onChange={(key, value) => {
          if (key.includes("custom")) return;
          setSearchQuery(searchQuery.set(key.replace("custom/", "") as keyof SearchQuery, value));
        }}
      />

      <div className="md:w-1/4">
        <Button disabled={!canSubmit} onClick={onSubmit}>
          Perform search
        </Button>
      </div>
    </div>
  );
});

export default AdvancedSearchMenu;
